


























































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";
import { mapGetters } from "vuex";
import MonthSelectorVue from "../components/MonthSelector.vue";
import ChooseSubjectVue from "../components/ChooseSubject.vue";
import version from "@/version";
@Component({
  components: {
    "month-selector": MonthSelectorVue,
    "choose-subject": ChooseSubjectVue
  }
})
export default class MultiSubsidiary extends Vue {
    subjectVal: Subject.Subject | null = null;
    subList: Subject.Subject[] = [];

    assistVal: string | null = null;

  noAssistList: DataTable.DropItem[] = [
    {
      id: 0,
      text: "只显示下级科目"
    },
    {
      id: 1,
      text: "只显示末级科目"
    }
  ];
  noAssistVal: number = 0;


      // 下载
  mainDownload() {
      if(this.subjectVal){
        let url = `${Vue.axios.defaults.baseURL}export/multi?accountBookId=${this.$store.state.accountBook.id}&subjectId=${this.subjectVal.id}&dimAccountType=${this.assistVal}&isLeaf=${this.noAssistVal}&startPeriod=${this.period[0]}&endPeriod=${this.period[1]}&version=${version}&token=${this.$store.state.account.token}`;
        this.$store.dispatch("toggleDownload", true);
        this.$utils.sendToElectron("download", url);
      }
    }

  async mounted() {
    await this.getSubjects();
    if (this.subjectVal) {
      if (
        (this.subjectVal.dimAccountTypes.length > 0 &&
          this.assistVal != null) ||
        this.subjectVal.dimAccountTypes.length === 0
      ) {
        this.fetchData();
      }
    }
  }
  // 获取科目
  getSubjects() {
    return new Promise<void>((resolve, reject) => {
      Vue.axios
        .post(
          "subjects/findunleaf?accountBookId=" +
            this.$store.state.accountBook.id
        )
        .then(res => {
          this.subList = res.data;
          resolve();
        });
    });
  }
  //改变时间
  period: String[] = []; // 日期
  changeDate(date: string[]) {
    this.period = date;
    this.fetchData();
  }

  // 选择科目
  changeSubject(val: Subject.Subject) {
    this.fetchData();
  }
  //选择Assist
  changeAssist(val: string) {
    this.assistVal = val;
    this.fetchData();
  }
  // 获取数据
  multiData: string[] = [];
  subsidiarys: Multi.Multi[] = [];
  fetchData() {
    if (this.subjectVal != null) {
      if (
        (this.subjectVal.dimAccountTypes.length > 0 &&
          this.assistVal != null) ||
        this.subjectVal.dimAccountTypes.length === 0
      ) {
        if (this.period.length === 2) {
          Vue.axios
            .post(`details/find/multi`, {
              accountBookId: this.$store.state.accountBook.id,
              subjectId: this.subjectVal.id,
              startPeriod: this.period[0],
              endPeriod: this.period[1],
              dimAccountType: this.assistVal,
              isLeaf: this.noAssistVal
            })
            .then(res => {
              this.multiData = res.data.multiDatas;
              this.subsidiarys = res.data.subsidiarys;
            });
        }
      }
    }
  }
  get summaryWidth(): number {
    if (this.multiData.length <= 1) {
      if (this.multiData.length === 1) return 290;
      else return 400;
    } else {
      return 200;
    }
  }

  get tbodyWidth(): string {
    if (this.multiData.length <= 1) {
      return "calc(100% + 10px)";
    } else {
      return "calc(103% + " + (this.multiData.length - 2) * 110 + "px)";
    }
  }

  get assistList(): string[] {
    return this.subjectVal === null || this.subjectVal === undefined
      ? []
      : this.subjectVal.dimAccountTypes;
  }
}
